module.exports = __webpack_public_path__ + "06_face.4fd21f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/06_face.png
// module id = slvn
// module chunks = 0